var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sub-menu',{attrs:{"icon":_vm.hiddenIcon ? null : 'mdi-web',"name":_vm.idiom.name,"items":_vm.items,"color":_vm.color,"item-class":"mx-auto"},on:{"click":_vm.handleLocale}})}
var staticRenderFns = []

export { render, staticRenderFns }